<template>
  <div id="portfolio-content" v-if="page.portfolio" :class="{'active': currentPage == 'portfolio-content'}">
    <div class="section">
      <div class="section__main reduced-width">
        <div class="portfolio">
          <Project :project="project" v-for="project in projects.item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Project from '@/components/Project';

export default {
  name: 'portfolioContent',
  data() {
    return {
      isAnimated: false,
    };
  },
  watch: {
    lang() {
      this.getData();
    },
  },
  components: {
    Project,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    projects: 'projects',
  }),
  methods: {
    getData() {
      this.$store.dispatch('fetchProjects', { lang: this.lang, $http: this.$http });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>




// WEBPACK FOOTER //
// src/pages/PortfolioContent.vue?187d594c